import { ApplicationConfig, isDevMode, provideBrowserGlobalErrorListeners } from '@angular/core';
import { RouteReuseStrategy, provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

import { routes } from './app.routes';
import { appInterceptor } from '@core/interceptors/app.interceptor';
import { APP_CONFIG, APP_CONFIG_SERVICE } from '@core/services/common/app-config.service';
import { CustomRouteReuseStrategy } from '@core/strategies/custom-route-reuse-strategy';
import { provideServiceWorker } from '@angular/service-worker';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([appInterceptor])),
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
    { provide: APP_CONFIG_SERVICE, useValue: APP_CONFIG },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'always' } },
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode()
    })
  ]
};
